// App.js - Main Application Component

import React, { useEffect, useState } from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import './styles/global.css';
import api from './utils/api';
import useStore from './store/useStore';
import LoginPage from './components/Auth/LoginPage';
import MainLayout from './components/Layout/MainLayout';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const { isAuthenticated, setUser } = useStore();

  useEffect(() => {
    // Check if user is already authenticated
    const checkAuth = async () => {
      try {
        if (api.isAuthenticated()) {
          // Token exists, fetch current user info (including isAdmin)
          const { user } = await api.getCurrentUser();
          setUser(user);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        api.logout();
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [setUser]);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#1a1a1a'
      }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <ReactFlowProvider>
      <MainLayout />
    </ReactFlowProvider>
  );
}

export default App;
